import {type PaletteMode} from '@mui/material/styles';
import {create, type StateCreator} from 'zustand';
import {persist} from 'zustand/middleware';

interface PreferencesStoreState {
  themeMode: PaletteMode;
  sidePanelExpanded: boolean;
}

interface PreferencesStoreActions {
  reset: () => void;
  toggleThemeMode: () => void;
  toggleSidePanelExpanded: () => void;
  setThemeMode: (themeMode: PaletteMode) => void;
  setSidePanelExpanded: (sidePanelExpanded: boolean) => void;
}

const preferencesStoreInitialState: PreferencesStoreState = {
  themeMode: 'dark',
  sidePanelExpanded: true,
};

export type PreferencesStore = PreferencesStoreState & PreferencesStoreActions;

const preferencesStoreHandler: StateCreator<PreferencesStore> = (setState) => ({
  ...preferencesStoreInitialState,
  reset: (): void => {
    setState(preferencesStoreInitialState);
  },
  setThemeMode: (themeMode): void => {
    setState({themeMode});
  },
  toggleThemeMode: (): void => {
    setState((state) => ({
      themeMode: state.themeMode === 'light' ? 'dark' : 'light',
    }));
  },
  setSidePanelExpanded: (sidePanelExpanded): void => {
    setState({sidePanelExpanded});
  },
  toggleSidePanelExpanded: (): void => {
    setState((state) => ({sidePanelExpanded: !state.sidePanelExpanded}));
  },
});

const PreferencesStoreMiddleWare = (
  f: StateCreator<PreferencesStore>,
): StateCreator<
  PreferencesStore,
  [],
  [['zustand/persist', PreferencesStore]]
> => persist(f, {name: 'preferences'});

export const usePreferencesStore = create<PreferencesStore>()(
  PreferencesStoreMiddleWare(preferencesStoreHandler),
);
